import { api } from '../index';
import {
  IInterviewRequestModel,
  IPlannedInterviewsByFullDate,
  IPlannedInterviewsByFullDateResponse,
  IPlannedInterviewsByMonthResponse,
  IShortInterview,
  TInterviewsResponse,
  TPlannedInterviewsByMonthParams,
  TUpdateInterviewNoteModel,
  TUpdateInterviewStatusModel,
} from './types';
import {
  IDefaultSuccessResponse,
  ITableParams,
  TAxiosResponse,
} from '../baseApiTypes';

const makeInterviewRequest = (data: IInterviewRequestModel) =>
  api.post<IDefaultSuccessResponse<string>>('interview/create', data);

const getInterviews = (
  params: ITableParams,
): TAxiosResponse<TInterviewsResponse> => api.get('/interview', { params });

const updateInterview = (interview: IShortInterview) =>
  api.post(`/interview/update/${interview.id}`, interview);

const updateInterviewStatus = (data: TUpdateInterviewStatusModel) =>
  api.post(`/interview/set-status/${data.id}`, data.data);

const updateInterviewNote = (data: TUpdateInterviewNoteModel) =>
  api.post(`/interview/add-note/${data.id}`, data.data);

const getPlannedInterviewsByMonth = (params: TPlannedInterviewsByMonthParams) =>
  api.get<IPlannedInterviewsByMonthResponse>('interview/calendar', {
    params,
  });

const getPlannedInterviewsByFullDate = (fullDate: string) =>
  api.get<IPlannedInterviewsByFullDateResponse>(
    `interview/calendar/${fullDate}`,
  );

export const getUpcomingInterviews = () =>
  api.get<IPlannedInterviewsByFullDateResponse>('/interview/upcoming');

export const InterviewApi = {
  makeInterviewRequest,
  getInterviews,
  updateInterview,
  updateInterviewStatus,
  updateInterviewNote,
  getPlannedInterviewsByMonth,
  getPlannedInterviewsByFullDate,
  getUpcomingInterviews,
};
